module.exports = __webpack_public_path__ + "img/d201112-2.e9ff02fe.jpg";